export const de = {
    test:
    {
        firstMessage: "Hallo Welt!",
        secondMessage: "Es {val}."
    }
};
